import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Tilt from "react-parallax-tilt";

function Positions() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
 <span className="purple"> </span>
            </h1>
            <p className="home-about-body">
            {/* We’re a web and mobile apps product development agency with a proven background in
SaaS, Media and Marketing Tech industry. */}
              <br />
              <i>
                <b className="purple">Learning is our oxygen – it is fundamental to our growth. We value the openness and curiosity to learn from anyone, anywhere.

We view honest failures as a learning opportunity. We learn from others and our challenges and successes. Through various internal growth programs, our goal is to carve out the right career growth path for all our people and empower them to innovate a better tomorrow. </b>
              </i>
              <br />
              <br />
              Grow More is an equal opportunity employer. All qualified applicants will receive consideration for employment without regard to sex, gender identity, sexual orientation, race, color, religion, national origin, disability, protected Veteran status, age, or any other characteristic protected by law. &nbsp;
              {/* <i>
                <b className="purple">Web Technologies and Products </b> and
                also in areas related to{" "}
                <b className="purple">
                  Blockchain.
                </b>
              </i> */}
              <br />
              <br />
              {/* Whenever possible, I also apply my passion for developing products
              with <b className="purple">Node.js</b> and */}
              <i>
                <b className="purple">
                  {" "}
                  {/* Grow More is a Agency in India We are a startup and founded in 2022 we are focusing on Technology Services. */}
                </b>
              </i>
              {/* &nbsp; like
              <i>
                <b className="purple"> React.js and Next.js</b>
              </i> */}
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={homeLogo} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>EXPLORE OPPORTUNITIES</h1>
            {/* <p>
              Feel free to <span className="purple">connect </span>with us
            </p> */}
            <ul className="home-about-social-links">
 
  <div>
    <div class="group bg-gray-900 p-4 transition-all duration-300 hover:rotate-1 lg:p-8">
      <div class="mb-3 text-right">
        {/* <button class="text-gray-50 transition-all duration-300 hover:scale-110 hover:text-red-600">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-6 w-6">
            <path d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z" />
          </svg>
        </button> */}
      </div>
      <div class="flex items-center gap-x-2">
        {/* <img class="aspect-[2/2] w-16" src="https://img.icons8.com/fluency/48/null/mac-os.png" /> */}
        <div>
          <h3 class="text-xl font-bold text-gray-50">Grow More</h3>
          <span class="text-xs text-gray-300">Remote</span>
        </div>
      </div>
      <div class="my-4">
        <h3 class="text-2xl font-medium text-gray-200">Full Stack Developer</h3>
        <div class="text-sm font-medium">
          <span class="m-1 ml-0 inline-block text-blue-500">React Native</span>
          <span class="m-1 ml-0 inline-block text-yellow-500">MongoDB</span>
          <span class="m-1 ml-0 inline-block text-pink-500">Node.js</span>
          {/* <span class="m-1 ml-0 inline-block text-lime-500"></span>
          <span class="m-1 ml-0 inline-block text-blue-500">Illustrator</span> */}
        </div>
        <div class="mt-2 text-sm text-gray-400">6K - 10K per Month</div>
      </div>
      <div class="flex items-center justify-between">
        <span class="text-sm font-medium text-gray-50">Part Time</span>
        <a class="font-medium text-red-500 transition-all duration-300 group-hover:text-blue-500/80">Expired</a>
      </div>
    </div>
  </div>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Positions;
